import { isNil, prop } from 'ramda'

const get = (obj, key) => (obj.get ? obj.get(key) : prop(key, obj))

export default obj =>
  (obj.keys ? obj.keys() : Object.keys(obj))
    .filter(key => !isNil(get(obj, key)))
    .map(key => `${key}=${encodeURIComponent(get(obj, key))}`)
    .join('&')
